export default "__VITE_ASSET__Db359GgI__"